import { render, staticRenderFns } from "./ShowAssignment.vue?vue&type=template&id=02ce25b4"
import script from "./ShowAssignment.vue?vue&type=script&lang=js"
export * from "./ShowAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports